<template>
  <v-app>
    <AppAlert />
    <AppLoading />
    <AppNotification />
    <router-view />
  </v-app>
</template>

<script>

import AppAlert from "@/components/common/AppAlert";
import AppLoading from "@/components/common/AppLoading";
import AppNotification from "@/components/common/AppNotification";

export default {
  components: {
    AppAlert,
    AppLoading,
    AppNotification,
  },
  computed: {
    orgName() {
      return this.$store.getters["organization/displayName"];
    },
    logoUrl() {
      return this.$store.getters["organization/logoUrl"];
    },
  },
  watch: {
    // The browser tab shows the organisation, and its logo as the tab icon when there is one.
    orgName: {
      immediate: true,
      handler(name) {
        document.title = name;
      },
    },
    logoUrl(url) {
      const icon = document.querySelector("link[rel~='icon']");
      if (!icon) return;
      if (!icon.dataset.original) icon.dataset.original = icon.getAttribute("href");
      icon.setAttribute("href", url || icon.dataset.original);
    },
  },
  created() {
    // Anonymous, so the login page can show the organisation's name and logo.
    this.$store.dispatch("organization/load");
  },
};
</script>
